<ion-list lines="none" class="list--support-links">
  <ion-item button detail="false" (click)="openOnlineChat()" class="ion-padding-top">
    <ion-icon aria-hidden="true" class="icon icon-click-to-chat-comments"></ion-icon>
    <ion-label class="ion-margin-start">
      <h3>Online chat</h3>
      <p>M-F, 8am-7pm CT</p>
    </ion-label>
  </ion-item>
  <ion-item button detail="false" href="tel:866-268-6879">
    <ion-icon aria-hidden="true" class="icon icon-phone-left"></ion-icon>
    <ion-label class="ion-margin-start">
      <h3>Call us at 866-268-6879</h3>
      <p>Then, choose from the following options:</p>
      <div class="call-container">
        <ul>
          <li>
            1 for <span class="text-bold">Claims</span>
            <ion-button fill="clear" class="tooltip link-button icon-only" aria-label="Claims Info"
              (click)="tooltipProvider.showTooltip($event, 'Open 24/7 to report a new claim. Existing claim inquiries M-F 8am-7pm CT.')">
              <i class="icon icon-info-circle-light" aria-hidden="true"></i>
            </ion-button>
          </li>
          <li>
            3 for <span class="text-bold">Billing</span>
            <ion-button fill="clear" class="tooltip link-button icon-only" aria-label="Billing Info"
              (click)="tooltipProvider.showTooltip($event, 'M-F 8am-7pm CT')">
              <i class="icon icon-info-circle-light" aria-hidden="true"></i>
            </ion-button>
          </li>
          <li>
            4 for <span class="text-bold">all other inquiries</span>
            <ion-button fill="clear" class="tooltip link-button icon-only" aria-label="Other Inquiries Info"
              (click)="tooltipProvider.showTooltip($event, 'M-F 8am-7pm, Sat 9am-5:30pm CT')">
              <i class="icon icon-info-circle-light" aria-hidden="true"></i>
            </ion-button>
          </li>
        </ul>
      </div>
    </ion-label>
  </ion-item>
  @if (isLoggedIn() && showRequestChange) {
    <ion-item button detail="false" (click)="navigateToRequestChange()">
    <ion-icon aria-hidden="true" class="icon icon-pen-to-square-light"></ion-icon>
    <ion-label class="ion-margin-start">
      <h3>Request a change</h3>
      <p>Manage policies</p>
    </ion-label>
  </ion-item>
    
  }
</ion-list>

@if (!isLoggedIn()) {
<ion-list class="list--assisted-registration ion-margin-top ion-padding-top">
  <ion-list-header>
    <ion-label>Assisted account registration</ion-label>
  </ion-list-header>
  <div class="card--inner" (click)="navigateToAssistedRegistration()">
    <ion-label class="flex justify-content-between">
      <div class="ion-padding-end">
        <p class="text-bold registration-code-text">Have a 10 digit registration code?</p>
        <p class="ion-padding-top">Create an account with the code provided to you by Client Support.</p>
      </div>
      <div class="flex align-center icon-container">
        <ion-icon class="icon icon-chevron-right text-semibold"></ion-icon>
      </div>
    </ion-label>
  </div>
</ion-list>
}

<ion-list class="list--external-links ion-margin-top ion-padding-top" role="list">
  <ion-list-header>
    <ion-label>Popular FAQs</ion-label>
  </ion-list-header>

  <ion-item button detail="false" [href]="httpHelper.getStaticWebUrl()+'/en/client-support/faqs/billing.html'"
    target="_blank" rel="noopener" role="listitem">
    <ion-icon slot="end" name="open-outline" aria-hidden="true"></ion-icon>
    <ion-label color="primary">Billing &amp; payments FAQs</ion-label>
  </ion-item>

  <ion-item button detail="false" [href]="httpHelper.getStaticWebUrl() + '/en/client-support/faqs/claims.html'"
    target="_blank" rel="noopener" role="listitem">
    <ion-icon slot="end" name="open-outline" aria-hidden="true"></ion-icon>
    <ion-label color="primary">Claims FAQs</ion-label>
  </ion-item>

  <ion-item button detail="false"
    [href]="httpHelper.getStaticWebUrl()+ '/en/client-support/faqs/online-account-access.html'" target="_blank"
    rel="noopener" role="listitem">
    <ion-icon slot="end" name="open-outline" aria-hidden="true"></ion-icon>
    <ion-label color="primary">Online account FAQs</ion-label>
  </ion-item>

  <ion-item button detail="false" [href]="httpHelper.getStaticWebUrl()+ '/en/client-support/faqs.html'" target="_blank"
    rel="noopener" role="listitem">
    <ion-icon slot="end" name="open-outline" aria-hidden="true"></ion-icon>
    <ion-label color="primary">See all FAQs</ion-label>
  </ion-item>
</ion-list>